"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSlider = exports.StyledLinkTabTitle = exports.StyledLinkTabListItem = exports.StyledTabTitle = exports.StyledTabListItem = exports.StyledTabs = exports.StyledLogo = exports.StyledRightPanel = exports.StyledLeftPanel = exports.StyledPanel = exports.StyledTabsWrapper = exports.StyledTabBadge = void 0;

const styled_components_1 = __importStar(require("styled-components"));

exports.StyledTabBadge = styled_components_1.default.div`
  margin-left: 9px;

  ${props => props.badgeValue !== null ? (0, styled_components_1.css)`
          display: initial;
        ` : (0, styled_components_1.css)`
          display: none;
        `}
`;
exports.StyledTabsWrapper = styled_components_1.default.div`
  width: 100%;
  height: ${props => {
  if (props.isLinkTab) {
    return props.theme.isMobile ? '45px' : '60px';
  }

  return props.theme.isMobile ? '50px' : '60px';
}};
  margin: 0;
  box-sizing: border-box;
  position: ${props => {
  return props.fixed ? 'fixed' : 'relative';
}};

  & * {
    box-sizing: border-box;
  }
`;
exports.StyledPanel = styled_components_1.default.div`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.bgColor || props.theme.colors.primary_700_main};
  width: 100%;
  height: 100%;
`;
exports.StyledLeftPanel = styled_components_1.default.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  height: inherit;
  width: inherit;
`;
exports.StyledRightPanel = styled_components_1.default.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  height: inherit;
  padding-right: 24px;
`;
exports.StyledLogo = styled_components_1.default.div`
  display: inline-flex;
  align-items: center;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0 60px 0 24px;
  height: 100%;
`;
exports.StyledTabs = styled_components_1.default.ul`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  position: relative;
  height: 100%;
  width: inherit;
  background-color: ${props => props.bgColor || props.theme.colors.primary_700_main};
  border: 1px solid ${props => props.bgColor || props.theme.colors.primary_700_main};
  border-bottom: none;
  margin: 0;
  padding: 0;
`;
exports.StyledTabListItem = styled_components_1.default.li`
  display: flex;
  align-items: flex-end;
  position: relative;
  height: ${props => props.theme.isMobile ? '45px' : '55px'};
  cursor: default;
  user-select: none;
  padding: 0 11px ${props => props.theme.isMobile ? '8px' : '10px'};
  margin: 0 -5px;
  background-color: ${props => props.isSelected ? props.theme.colors.white : props.bgColor || props.theme.colors.primary_700_main};
  color: ${props => props.isSelected ? props.bgColor || props.theme.colors.primary_700_main : props.theme.colors.white};
  font-family: 'Roboto', sans-serif;
  font-size: ${props => props.theme.fontSizes[14]};
  border: 1px solid
    ${props => props.isSelected ? props.theme.colors.white : props.bgColor || props.theme.colors.primary_700_main};
  border-bottom: none;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  white-space: nowrap;

  ${props => props.isSelected && (0, styled_components_1.css)`
      margin: 0 15px;

      &:before,
      &:after {
        border: 1px solid
          ${props.isSelected ? props.theme.colors.white : props.bgColor || props.theme.colors.primary_700_main};
        position: absolute;
        bottom: 0;
        width: 8px;
        height: ${props.theme.isMobile ? '30px' : '40px'};
        content: ' ';
      }

      &:before {
        left: -8px;
        bottom: -3px;
        border-bottom-right-radius: 16px;
        border-width: 0 8px 3px 0;
      }

      &:after {
        right: -8px;
        bottom: -3px;
        border-bottom-left-radius: 16px;
        border-width: 0 0 3px 8px;
      }
    `}

  ${props => props.theme.isMobile && (0, styled_components_1.css)`
      justify-content: center;
      width: 100%;
    `}
`;
exports.StyledTabTitle = styled_components_1.default.div`
  display: inline-flex;
  align-items: center;
  position: relative;
  height: ${props => props.theme.isMobile ? '30px' : '40px'};
  cursor: pointer;
  user-select: none;
  color: ${props => props.isSelected ? props.bgColor || props.theme.colors.primary_700_main : props.theme.colors.white};
  font-family: 'Roboto', sans-serif;
  font-size: ${props => props.theme.fontSizes[14]};
  padding: 0 11px;

  ${props => !props.theme.isMobile && !props.isSelected && (0, styled_components_1.css)`
      &:hover {
        background-color: #ffffff33;
        border-radius: 20px;
      }
    `}

  ${props => props.theme.isMobile && (0, styled_components_1.css)`
      -webkit-tap-highlight-color: transparent;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    `}

  ${props => props.isSelected && (0, styled_components_1.css)`
      cursor: default;
    `}
`;
exports.StyledLinkTabListItem = styled_components_1.default.li`
  display: inline-flex;
  align-items: flex-end;
  position: relative;
  height: ${props => props.theme.isMobile ? '45px' : '55px'};
  cursor: default;
  user-select: none;
  margin-right: 10px;
  padding-bottom: ${props => props.theme.isMobile ? '3px' : '10px'};
  background-color: ${props => props.bgColor || props.theme.colors.white};
  color: ${props => props.isSelected ? props.bgColor || props.theme.colors.primary_700_main : props.theme.colors.black_main};
  font-family: 'Roboto', sans-serif;
  font-size: ${props => props.theme.fontSizes[14]};
  border: 1px solid ${props => props.bgColor || props.theme.colors.white};
  border-bottom: none;
  white-space: nowrap;
`;
exports.StyledLinkTabTitle = styled_components_1.default.div`
  display: inline-flex;
  align-items: center;
  position: relative;
  height: 40px;
  padding: 0 10px;
  cursor: pointer;
  user-select: none;
  color: ${props => props.isSelected ? props.bgColor || props.theme.colors.primary_700_main : props.theme.colors.black_main};
  font-family: 'Roboto', sans-serif;
  font-size: ${props => props.theme.fontSizes[14]};

  ${props => !props.theme.isMobile && !props.isSelected && (0, styled_components_1.css)`
      &:hover {
        background-color: ${props.theme.colors.beige_100};
        border-radius: 20px;
      }
    `}

  ${props => props.theme.isMobile && (0, styled_components_1.css)`
      -webkit-tap-highlight-color: transparent;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    `}

  ${props => props.isSelected && (0, styled_components_1.css)`
      cursor: default;
    `}
`;
exports.StyledSlider = styled_components_1.default.li`
  position: absolute;
  height: 3px;
  display: block;
  background-color: ${props => props.sliderColor || props.theme.colors.primary_700_main};
  transform-origin: 0 0;
  -webkit-transition: 0.3s ease;
  transition: transform 0.3s ease;
  width: ${props => `${props.width || 0}px`};
  transform: translateX(${props => `${props.left || 0}px`});
  animation: 0.3s ease-in forwards;
`;